@if (action() == 'add') {
  <div class="container my-2">
    <h4 class="mb-10 mt-4">Add User Property Role</h4>
    <form [formGroup]="addPropertyRole" (ngSubmit)="onSubmitVerify()">
      <div class="form-outline">
        <div class="row mb-2">
          <div class="col-md-6">
            <input type="text" class="form-control" formControlName="username" placeholder="Enter username here" [ngClass]="{ 'is-invalid': submitQuery() && fa.username.errors }">
            <label class="form-label" for="username">Username</label>
            @if (submitQuery() && fa.username.errors) {
              <div class="invalid-feedback d-block mb-2">
                @if (fa.username.errors.required) {
                  <div>Username is required</div>
                }
              </div>
            }
          </div>
          <div class="col-md-6">
            <select class="form-select form-control" formControlName="propertyid" aria-label="Property selection" [ngClass]="{ 'is-invalid': submitQuery() && fa.propertyid.errors }">
              <option selected>Choose Property</option>
              @for (property of proplist(); track property) {
                <option [value]="property.id">{{property.name}}</option>
              }
            </select>
            <label class="form-label" for="propertyid">Property</label>
            @if (submitQuery() && fa.propertyid.errors) {
              <div class="invalid-feedback d-block mb-2">
                @if (fa.propertyid.errors.required) {
                  <div>Please select a property</div>
                }
              </div>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <select class="form-select form-control" formControlName="rolename" aria-label="Property selection" [ngClass]="{ 'is-invalid': submitQuery() && fa.rolename.errors }">
              <option selected>Choose Role</option>
              <option value="ROLE_ADMIN">Administrator</option>
            </select>
            <label class="form-label" for="propertyid">User Role</label>
            @if (submitQuery() && fa.rolename.errors) {
              <div class="invalid-feedback d-block mb-2">
                @if (fa.rolename.errors.required) {
                  <div>Please select a role</div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row">
        @if (showVerifyBtn()) {
          <div class="col-sm-3">
            <button type="submit" class="btn btn-primary btn-block mb-2">Save User Role <fa-icon class="ml-2" [icon]="faSave"></fa-icon></button>
          </div>
        }
      </div>
    </form>
  </div>
}

@if (action() == 'confirm') {
  <div class="container mt-2">
    <h4 class="mb-10 mt-4">Add User Property Role</h4>
    <form [formGroup]="confirmPropertyRole" (ngSubmit)="onSubmitConfirm()">
      <div class="form-outline">
        <div class="row mb-2">
          <div class="col-md-6">
            <input type="text" class="form-control" formControlName="username" placeholder="Enter username here" [ngClass]="{ 'is-invalid': submitQuery() && fe.username.errors }">
            <label class="form-label" for="username">Username</label>
            @if (submitQuery() && fe.username.errors) {
              <div class="invalid-feedback d-block mb-2">
                @if (fe.username.errors.required) {
                  <div>Username is required</div>
                }
              </div>
            }
          </div>
          <div class="col-md-6">
            <select class="form-select form-control" formControlName="propertyid" aria-label="Property selection" [ngClass]="{ 'is-invalid': submitQuery() && fe.propertyid.errors }">
              <option selected>Choose Property</option>
              @for (property of proplist(); track property) {
                <option [value]="property.id">{{property.name}}</option>
              }
            </select>
            <label class="form-label" for="propertyid">Property</label>
            @if (submitQuery() && fe.propertyid.errors) {
              <div class="invalid-feedback d-block mb-2">
                @if (fe.propertyid.errors.required) {
                  <div>Please select a property</div>
                }
              </div>
            }
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-6">
            <div class="form-outline">
              <input type="text" id="firstName" formControlName="firstName" class="form-control" placeholder="e.g John" [ngClass]="{ 'is-invalid': submitAdd() && fe.firstName.errors, 'is-valid': fe.firstName.valid && fe.firstName.touched }"/>
              <label class="form-label" for="firstName">First name</label>
              @if (submitAdd() && fe.firstName.errors) {
                <div class="invalid-feedback mb-2">
                  @if (fe.firstName.errors.required) {
                    <div>First name is required</div>
                  }
                </div>
              }
              @if (fe.firstName && fe.firstName.errors?.pattern) {
                <div class="invalid-feedback mb-2">
                  First name should have 2 or more letters
                </div>
              }
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-outline">
              <input type="text" id="lastName" formControlName="lastName" class="form-control" placeholder="e.g Brown"  [ngClass]="{ 'is-invalid': submitAdd() && fe.lastName.errors, 'is-valid': fe.lastName.valid && fe.lastName.touched }"/>
              <label class="form-label" for="lastName">Last name</label>
              @if (submitAdd() && fe.lastName.errors) {
                <div class="invalid-feedback mb-2">
                  @if (fe.lastName.errors.required) {
                    <div>Last name is required</div>
                  }
                </div>
              }
              @if (fe.lastName && fe.lastName.errors?.pattern) {
                <div class="invalid-feedback mb-2">
                  Last name should have 2 or more letters
                </div>
              }
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <select class="form-select form-control" formControlName="rolename" aria-label="Property selection" [ngClass]="{ 'is-invalid': submitQuery() && fe.rolename.errors }">
              <option selected>Choose Role</option>
              <option value="ROLE_ADMIN">Administrator</option>
            </select>
            <label class="form-label" for="propertyid">User Role</label>
            @if (submitQuery() && fe.rolename.errors) {
              <div class="invalid-feedback d-block mb-2">
                @if (fe.rolename.errors.required) {
                  <div>Please select a role</div>
                }
              </div>
            }
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <button type="submit" class="btn btn-primary btn-block mb-2">Confirm <fa-icon class="ml-2" [icon]="faPaperPlane"></fa-icon></button>
        </div>
      </div>
    </form>
  </div>
}


@if (action() == 'list' || action() == null) {
  <div class="container mt-2">
    <div class="row">
      <div class="form-group has-search col-md-8">
        <fa-icon class="form-control-feedback" [icon]="faSearch"></fa-icon>
        <input type="text" name="search" [ngModel]="searchRoles()" (ngModelChange)="searchRoles.set($event)" class="form-control" placeholder="Search by name, phone" autocomplete="off">
      </div>
      <div class="col-md-4">
        <button (click)="addUserRole()" class="btn btn-success mb-2">Add User Role <fa-icon [icon]="faPlusCircle"></fa-icon></button>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row">
        <div class="col-sm divth">
          Username
        </div>
        <div class="col-sm divth">
          Full Name
        </div>
        <div class="col-sm divth">
          Role Name
        </div>
        <div class="col-sm divth">
          Property Name
        </div>
        <div class="col-sm divth">
          Approved
        </div>
        <div class="col-sm divth">
          Action(s)
        </div>
      </div>
    </div>
    @for (roleprop of proproles() | filter: searchRoles(); track roleprop) {
      <div class="col-md-12">
        <div class="row">
          <div class="col-sm divtd">
            {{roleprop.username}}
          </div>
          <div class="col-sm divtd">
            {{roleprop.fullname}}
          </div>
          <div class="col-sm divtd">
            {{roleprop.rolename}}
          </div>
          <div class="col-sm divtd">
            {{roleprop.propertyname}}
          </div>
          <div class="col-sm divtd" [ngClass]="{'text-success': roleprop.approved,'text-danger': !roleprop.approved}">
            {{roleprop.approved}} @if (roleprop.approved) {
            <fa-icon class="ml-2" [icon]="faCheckCircle"></fa-icon>
            } @if (!roleprop.approved) {
            <fa-icon class="ml-2" [icon]="faTimesCircle"></fa-icon>
          }
        </div>
        <div class="col-sm divtd">
          @if (!roleprop.approved) {
            <td>
              <button (click)="approveRole(roleprop.id)" class="btn btn-success acbtn">@if (help()) {
                <span class="mr-2">Approve</span>
                } <fa-icon [icon]="faCheckCircle"></fa-icon></button>
              </td>
            }
            @if (roleprop.approved) {
              <td>
                <button (click)="revokeRole(roleprop.id)" class="btn btn-danger acbtn">@if (help()) {
                  <span class="mr-2">Revoke</span>
                  } <fa-icon [icon]="faBan"></fa-icon></button>
                </td>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
